export class MissingEcommerceEventHandlerError extends Error {
  constructor(message?: string) {
    super(message); // Call the parent Error class constructor
    this.name = "MissingEcommerceEventHandlerError"; // Set the name property for identification
  }
}
